import { FooterModule } from 'ui/components/3-organisms/FooterModule';

export const FooterModuleFeature: React.FC<Umbraco.FooterModule> = ({ content }) => <FooterModule {...content?.properties} />;
